import { Box, Divider, Typography } from "@mui/material";
import Nav from "./Nav";

export default function Page({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        height: "100vh",
        width: "100vw",
        padding: 2,
      }}
    >
      <Nav />
      <Typography variant="h6">{title}</Typography>
      <Divider sx={{ my: 2, width: "100%", color: "divider" }} />
      {children}
    </Box>
  );
}
